// extracted by mini-css-extract-plugin
module.exports = {"css-transition":"Base_css-transition__3-Zb1","anchor":"Base_anchor__2nDUU"};